import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectIsAuthenticated, selectRole } from '../../store/adminSlices/auth';
import { useEffect } from 'react';
import { APP_ROUTES } from '../../app.config.vars/routes';
const SuperAdminPrivateRoute = ({ children }) => {
    const navigate = useNavigate();
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const role = useSelector(selectRole);
    useEffect(() => {
        if (!isAuthenticated || role !== 'super_admin') {
            navigate(`${APP_ROUTES.adminLogin}?ref=${location.pathname}`, { replace: true });
        }
    }, [isAuthenticated, role, navigate]);
    return isAuthenticated && role === 'super_admin' ? children : null;
};
export default SuperAdminPrivateRoute;
